import { render, staticRenderFns } from "./Botones.vue?vue&type=template&id=0df86698&"
import script from "./Botones.vue?vue&type=script&lang=js&"
export * from "./Botones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports